// Live transcription used to report "No speech was detected" only after Stop,
// so a wrong microphone or transcription language could cost a whole session.
// This watchdog fires once if nothing is heard within `timeoutMs` of the
// recognizer starting, and tells the caller to clear the warning as soon as
// speech arrives. It only watches the start of a session: normal pauses later
// in a consultation must not trigger it.
export const NO_SPEECH_TIMEOUT_MS = 10 * 1000; // Cath: alert early (10 s)

export function createNoSpeechWatchdog({ timeoutMs = NO_SPEECH_TIMEOUT_MS, onSilence, onSpeech } = {}) {
  let timer = setTimeout(() => {
    timer = null;
    onSilence?.();
  }, timeoutMs);
  let heardSpeech = false;

  return {
    /** Call on any recognised speech, partial or final. Clears the warning once. */
    heard() {
      if (heardSpeech) return;
      heardSpeech = true;
      if (timer) { clearTimeout(timer); timer = null; }
      onSpeech?.();
    },
    /** Call when the session stops, is cancelled or fails to start. */
    stop() {
      if (timer) { clearTimeout(timer); timer = null; }
    },
  };
}
